import {useQuery} from "vue-query";
import {usePaymentCard} from "../hooks/usePaymentCard";

const {
  getCards: getCardsRequest,
} = usePaymentCard();

export const getCards = (options) => useQuery(['paymentCards'], () => getCardsRequest(), options);
